import type {ReactAction} from '@netx/core/bootstrap';
import {faSearch} from '@netx/core-icons';
import {type ICategory} from '@netx/core-category-next/schema';
import {CategoryActionLabel} from '../locales';
import {CATEGORY_EVENT} from './constants';
import {canSearchCategory} from '../enablers';

export const categoryActionSearchAllAssetsIcon = faSearch;

/**
 * Search all assets in category (inclusing sub cats)
 * @param params
 * @returns Action
 */
export const categoryActionSearchAllAssets = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'category-search-all-assets',
	cb: () =>
		dispatcher.trigger(CATEGORY_EVENT.SEARCH_ALL_ASSETS, category?.categoryid),
	enableTest: () => canSearchCategory(category),
	icon: categoryActionSearchAllAssetsIcon,
	get label() {
		return CategoryActionLabel.SEARCH_ALL_ASSETS;
	},
	...params,
});

export default categoryActionSearchAllAssets;
